import {app} from '../../app';
import {RadioQuestionComponent} from "./RadioQuestionComponent";


export class BarsQuestionComponent extends RadioQuestionComponent {

    definitions:IBarsDefinition[] = [];
    definitionsWidth:number[]     = [];
    choicesWidth:number[]          = [];

    setup() {
        super.setup();

        if (this.question.meta.definitions) {
            this.definitions = this.question.meta.definitions;

            for (let definition of this.definitions) {
                this.definitionsWidth.push(definition.forChoices.length / this.choices.length * 100);
            }
        }

        for (let choice of this.choices) {
            this.choicesWidth.push(1 / this.choices.length * 100);
        }
    }

}

app.component('barsQuestion', {
    templateUrl : 'templates/components/questionTypes/barsQuestion.html',
    controller  : BarsQuestionComponent,
    controllerAs: 'barsQuestion',
    bindings    : {
        question            : '<',
        nextQuestionCallback: '&'
    }
});